import ConstansScore from "../../../../src/client/katnh/widgets/ConstansScore.js";
import * as React from 'react';
export default {
  ConstansScore,
  React
};